var lastGeneratedId = 0;
export var generateButtonId = function () { return "awsui-radio-button-" + lastGeneratedId++; };
export var generateGroupName = function (tagName) { return tagName + "-" + lastGeneratedId++; };
export var isRadioButton = function (el) {
    return el.component && el.component.__componentName === 'awsui-radio-button';
};
//# sourceMappingURL=utils.js.map